import React from 'react';
import { Button, Alert } from '@parsina/framework';

import { C, CT } from '../../constants/theme';
import { useTranslation } from '../../i18n/I18nProvider.jsx';
import OnboardingFields from './OnboardingFields.jsx';

// The phone frame: one full-height scroll, a title band, and the submit docked
// at the end of the form rather than floating over it.
//
// No card and no gradient: a 360px viewport spends its whole width on the
// fields, and a centred card there is a box with a 40px reading column. The
// header is plain text rather than a `MobileHeader`, because there is nowhere
// to go back TO — this screen has no shell around it and no route behind it.

const ROOT = {
  position: 'fixed',
  inset: 0,
  overflowY: 'auto',
  background: C.bg,
  padding: '24px 16px 40px',
  paddingInlineStart: 'max(16px, env(safe-area-inset-left, 0px))',
  paddingInlineEnd: 'max(16px, env(safe-area-inset-right, 0px))',
};

export default function OnboardingMobile({
  values,
  onChange,
  errors,
  submitError,
  saving,
  onSubmit,
  phone,
}) {
  const { t } = useTranslation();

  return (
    <div style={ROOT} data-testid="onboarding-mobile">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <h1 style={{ color: C.navy, fontSize: 19, fontWeight: 800, margin: '0 0 6px' }}>
          {t('onboarding.title')}
        </h1>
        <p style={{ color: CT.mute, fontSize: 13, lineHeight: 1.9, margin: '0 0 18px' }}>
          {t('onboarding.sub')}
        </p>

        {submitError && (
          <Alert variant="error" style={{ marginBottom: 14 }} data-testid="onboarding-error">
            {submitError}
          </Alert>
        )}

        <OnboardingFields
          values={values}
          onChange={onChange}
          errors={errors}
          disabled={saving}
          phone={phone}
        />

        {/* Full width and 44px tall: this is the only action on the screen, and
            it is the last thing under a thumb that has just scrolled the form. */}
        <Button
          type="submit"
          disabled={saving}
          className="w-full min-h-11"
          style={{ marginTop: 22 }}
          data-testid="onboarding-submit"
        >
          {saving ? t('onboarding.saving') : t('onboarding.submit')}
        </Button>
      </form>
    </div>
  );
}
